export default "__VITE_ASSET__DdnIGJgq__"